import { RobotoLoadingButton } from "@/shared/components";
import { EventRecord } from "@/shared/domain/events";

import { useDeleteWorkspaceEvent } from "../../WorkspaceCtx/useWorkspaceEvents";

interface DeleteEventProps {
  eventId: EventRecord["event_id"];
  onError: (error: Error) => void;
  onSuccess: () => void;
}

export function DeleteEvent({ eventId, onError, onSuccess }: DeleteEventProps) {
  const deleteEventMutation = useDeleteWorkspaceEvent();

  const onDelete = () => {
    deleteEventMutation.mutate(eventId, {
      onSuccess,
      onError: (error) => {
        // Display a user friendly error when the request fails.
        onError(
          new Error(
            "We're having trouble deleting the event. Please try again later.",
            {
              cause: error,
            },
          ),
        );
      },
    });
  };

  return (
    <RobotoLoadingButton
      eventName={"WorkspaceEventDeleted"}
      eventProperties={{ eventId }}
      variant="contained"
      color="error"
      onClick={onDelete}
      loading={deleteEventMutation.isPending}
    >
      Delete Event
    </RobotoLoadingButton>
  );
}
